import { css } from '@emotion/react';
import { useMemo } from 'react';
import theme from './theme';
const sizes = {
    large: 'large',
    medium: 'medium',
    small: 'small',
};
const types = {
    primary: 'primary',
    secondary: 'secondary',
    secondaryAlternate: 'secondaryAlternate',
    tertiary: 'tertiary',
    tertiaryAlternate: 'tertiaryAlternate',
};
const sizeStyles = {
    [sizes.large]: theme.typeStyles.bodyLargeStyles,
    [sizes.medium]: theme.typeStyles.bodyMediumStyles,
    [sizes.small]: theme.typeStyles.bodySmallStyles,
};
const variationStyles = {
    primary: {
        hoverTextDecoration: 'underline',
        textDecoration: 'none',
    },
    secondary: {
        hoverTextDecoration: 'none',
        textDecoration: 'underline',
    },
    secondaryAlternate: {
        hoverTextDecoration: 'underline',
        textDecoration: 'none',
    },
    tertiary: {
        hoverTextDecoration: 'none',
        textDecoration: 'underline',
    },
    tertiaryAlternate: {
        hoverTextDecoration: 'underline',
        textDecoration: 'none',
    },
};
const useLinkStyles = ({ size, type, }) => (useMemo(() => (css `
        ${sizeStyles[size]}
        ${type === 'primary' && theme.typeStyles.bodyBoldStyles}

        color: inherit;
        text-decoration: ${variationStyles[type].textDecoration};

        &:hover {
          color: inherit;
          text-decoration: ${variationStyles[type].hoverTextDecoration};
        }
`), [
    type,
    size,
]));
export default useLinkStyles;
